import { render, staticRenderFns } from "./NewMarketProfile.vue?vue&type=template&id=6ea30c54"
import script from "./NewMarketProfile.vue?vue&type=script&lang=js"
export * from "./NewMarketProfile.vue?vue&type=script&lang=js"
import style0 from "./NewMarketProfile.vue?vue&type=style&index=0&id=6ea30c54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports